<script setup lang="ts">
import DatePicker from "primevue/datepicker";
import {computed} from "vue";
import dayjs from "dayjs";

const props = defineProps({
    minDate: null,
    maxDate: null,
});
const model = defineModel();
const date = computed({
    get: () => {
        if (model.value) {
            return dayjs(model.value).toDate();
        }
        return model.value;
    },
    set: (value) => (model.value = value),
});
const minDate = computed(() => {
    if (props.minDate) {
        return dayjs(props.minDate).toDate();
    }
    return props.minDate;
});

const maxDate = computed(() => {
    if (props.maxDate) {
        return dayjs(props.maxDate).toDate();
    }
    return props.maxDate;
});
</script>
<template>
    <DatePicker v-model="date" :min-date="minDate" :max-date="maxDate" :showIcon="true" />
</template>
<style scoped></style>
